/**
 * Sends uncaught browser errors to the server (POST /api/client-errors), which groups them into an
 * email digest for the admins. Each message is sent once per page load, at most MAX per load, and
 * never in development.
 */
const MAX = 10;
const sent = new Set<string>();

export function reportError(err: unknown, extra?: string): void {
  if (import.meta.env.DEV || import.meta.env.MODE === "test") return;
  const e = err instanceof Error ? err : new Error(typeof err === "string" ? err : JSON.stringify(err));
  const message = `${e.name}: ${e.message}${extra ? ` (${extra})` : ""}`.slice(0, 500);
  if (sent.has(message) || sent.size >= MAX) return;
  sent.add(message);
  const body = JSON.stringify({ message, stack: e.stack?.slice(0, 2000), url: window.location.href.slice(0, 300) });
  try {
    fetch("/api/client-errors", { method: "POST", headers: { "Content-Type": "application/json" }, body, keepalive: true }).catch(() => {});
  } catch {
    // Reporting must never break the page.
  }
}

export function installErrorReporting(): void {
  window.addEventListener("error", (ev) => reportError(ev.error ?? ev.message));
  window.addEventListener("unhandledrejection", (ev) => reportError(ev.reason));
}
